import { Component } from '@angular/core';

import {
  CamWebPushManagerComponent,
  ChoiceDetailComponent,
  CommunicationStatusComponent,
  CommunicationTemplateChoiceComponent,
  CommunicationTypeComponent,
} from '@camelot/core';

import { TestIdDirective } from '@camelot/testing-harness';

const variantMock = {
  body: '',
  culture: 1,
  documentIds: [],
  id: 'variant-1',
  jsonBody: '',
  jsonBodyParsed: [],
  title: 'variant',
} as never;

@Component({
    imports: [
        CamWebPushManagerComponent,
        ChoiceDetailComponent,
        CommunicationStatusComponent,
        CommunicationTemplateChoiceComponent,
        CommunicationTypeComponent,
        TestIdDirective,
    ],
    template: `
    <cam-communication-status camTestId="cam-communication-status" [value]="1" />
    <cam-communication-type camTestId="cam-communication-type" [value]="1" />
    <cam-communication-template-choice camTestId="cam-communication-template-choice" [type]="this.type" />
    <cam-choice-detail camTestId="cam-choice-detail" [variant]="this.variant" />
    <cam-web-push-manager camTestId="cam-web-push-manager" />
  `
})
export class CoreCommunicationCase {
  public type = 1;
  public variant = variantMock;
}
